<template>
  <div data-cy="DeviceForm">
    <VTextField
      v-model="data.type"
      :label="`${$t('forms.labels.type')}`"
      :rules="{ required: true, min: 1, max: 50 }"
      outlined
      @input="updateData"
    />
    <VTextField
      v-model="data.model"
      :label="`${$t('forms.labels.model')}`"
      :rules="{ required: true, min: 1, max: 50 }"
      outlined
      @input="updateData"
    />
    <v-row
      v-for="(des, index) in data.description"
      :key="index"
      align="center"
      justify="center"
    >
      <v-col
        alignSelf="end"
        md="2"
        cols="12"
      >
        <VSelect
          v-model="des.lang"
          :label="$t('forms.labels.lang')"
          :items="langs"
          itemValue="key"
          itemText="name"
          outlined
          @input="updateData"
        />
      </v-col>

      <v-col>
        <VTextField
          v-model="des.description"
          :label="$t('forms.labels.description')"
          :rules="{ max: 200 }"
          outlined
          @input="updateData"
        />
      </v-col>

      <v-btn
        icon
        :disabled="langs.length === totalDescLength"
        @click="onClickAddRow"
      >
        <v-icon>
          add
        </v-icon>
      </v-btn>
    </v-row>
    <div
      class="image-manager"
    >
      <FileManager
        :backendFiles="[data.picture]"
        :mimetype="acceptedFileMimetype.IMAGE"
        :canAdd="hasPermission('files.add')"
        :canEdit="hasPermission('files.edit')"
        :canView="hasPermission('files.view')"
        :canRemove="hasPermission('files.remove')"
        :isSingleFile="true"
        :onDeleteFile="removeFile"
        @fileAdded="handleFileAdded"
        @change="onDeviceImageSelection"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import FileManager from '@/components/shared/FileManager.vue';
import { LOCALES } from '@/locales/i18n';
import { cloneDeep } from 'lodash';
import acceptedFileMimetype from '@/constants/acceptedFileMimetype';

export default {
    components: {
        VTextField,
        FileManager,

    },
    props: {
        device: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            data: { type: null, model: null, description: {} },
            loading: false,
            selectedImage: [],
            descriptions: [],
        };
    },
    computed: {
        acceptedFileMimetype() {
            return acceptedFileMimetype;
        },
        ...mapGetters([
            'userLang',
            'hasPermission',
        ]),
        langs() {
            return LOCALES.map(lang => ({
                name: this.$t(`langs.${lang}`),
                key: lang,
                disabled: this.isLangUsed(lang),
            }));
        },
        isLangUsed() {
            return lang => Object.values(this.data.description).findIndex(des => des.lang === lang) >= 0;
        },
        totalDescLength() {
            return Object.keys(this.data.description).length;
        },
    },
    async created() {
        this.data = { ...this.data, ...cloneDeep(this.device) };
    },
    methods: {
        async handleFileAdded(newFile) {
            // Update backendFiles to include the new file
            this.data.selectedImage = newFile;
            this.$emit('sendData', this.data);
            const { data: deviceType } = await this.$rq.getDeviceById(this.data.id);
            this.prepareDeviceTypeOnEdit(deviceType);
        },
        updateData() {
            this.$emit('sendData', this.data);
        },
        async onDeviceImageSelection(fileVal) {
            this.data.selectedImage = [fileVal];
            this.updateData();
            const { data } = await this.$rq.getDeviceById(this.data.id);
            this.data = data;
        },
        async removeFile() {
            await this.$rq.deleteDeviceTypePicture(this.data.id);
            const { data: deviceType } = await this.$rq.getDeviceById(this.data.id);
            this.prepareDeviceTypeOnEdit(deviceType);
        },
        onClickAddRow() {
            const nonDisabledLang = this.langs.find(lang => !lang.disabled);
            const tempDesc = JSON.parse(JSON.stringify(this.data.description));
            this.data.description = { ...tempDesc, [nonDisabledLang.key]: { lang: nonDisabledLang.key, description: '' } };
        },
    },
};
</script>
